import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useFormikContext } from 'formik';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import HelloCustomer from 'components/HelloCustomer';
import CustomerPhoneField from 'forms/fields/PhoneField/CustomerPhoneField';
import EmailField from 'forms/fields/EmailField';
import FirstNameField from 'forms/fields/FirstNameField';
import LastNameField from 'forms/fields/LastNameField';
import Model from '../../../../../model';
import './index.sass';

const { block, el } = bem('payment-card-user-fields');

const UserFields = () => {
    const [ { isPhoneValid, customerName }, setCustomerInfo ] = useState({ isPhoneValid: false, customerName: null });
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        setFieldValue('customerFound', !!customerName);
    }, [ customerName, isPhoneValid ]);

    const preventCopyPasting = (e) => {
        e.preventDefault();
        return false
    }

    return (
        <div className={ block() }>
            <div className={ el('persistent-fields') }>
                <CustomerPhoneField name={ 'customerPhone' } setCustomerInfo={ setCustomerInfo }
                                    showGreeting={ false } />
                { customerName && <HelloCustomer customerName={ customerName } position={ 'bottom' }/> }
            </div>
            { isPhoneValid && !customerName && <div className={ el('new-customer-fields') }>
                <div className={ el('row') }>
                    <EmailField onPaste={ preventCopyPasting }/>
                    <EmailField name={ 'customerEmailConfirmation' } placeholder={ 'Подтвердите ваш Email' }
                                onPaste={ preventCopyPasting }/>
                </div>
                <div className={ el('row') }>
                    <FirstNameField/>
                    <LastNameField/>
                </div>
            </div> }
            <div className={ 'course-form__details' }>
                <Icon name={ 'info' }/>
                <Text>На Вашу почту будет отправлено письмо с подтверждением покупки и чек</Text>
            </div>
        </div>
    );
};

export default observer(UserFields);
